// extracted by mini-css-extract-plugin
export default {"header":"SideBarHeader_header__somOK","dark":"SideBarHeader_dark__JJyiY"};